import { useMutation } from '@tanstack/react-query';

import { get } from '@eika-infrastruktur/request';

import { KREDITTBANKEN_BASE_URL } from '@/react-query/common';

import { OcrInformation } from '@generated-types';

const getOcr = async (accountNumber: string) => get<OcrInformation>(`${KREDITTBANKEN_BASE_URL}/ocr/${accountNumber}`);

export const useAccountOcrMutation = () => {
    return useMutation({
        mutationKey: ['v4', 'ocr'],
        mutationFn: getOcr,
    });
};
